import React from 'react';
import { Box, Button, Image, Typography } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { imagesBcp } from '@assets';
import { rem } from '@helpers';
import { useServiceErrorHelper } from './serviceError.helper';

export const ServiceErrorPlaceholder: React.FC = () => {
	const { resources, onClickHandler } = useServiceErrorHelper();

	return (
		<>
			<Box
				styles={{
					width: '100%',
					marginTop: rem(69.03),
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Image source={imagesBcp.warningIcon} svgProps={{ width: rem(77.94), height: rem(77.94) }} />
			</Box>
			<Box
				styles={{
					display: 'flex',
					flexDirection: 'column',
					width: '100%',
					marginTop: rem(37.03),
					textAlign: 'center',
					marginBottom: rem(30),
				}}
			>
				<Typography appearance="headline-100-03">{resources.message}</Typography>
			</Box>
			<Box styles={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<Button onPress={onClickHandler}>{resources.button}</Button>
			</Box>
		</>
	);
};
